export default "__VITE_ASSET__DFaJQYKr__"